export enum EN_SERVICE_PLUGIN_SYMBOL {
  // ui配置
  UI_CONFIG = 'ui_config',
  // 投图设置补充
  PROJECTION_SETTING_REPLENISHER = 'projection_setting_replenisher',
  // 默认配置获取
  DEFAULT_PROJECTION_SETTING_CONFIG_PROVIDER = 'default_projection_setting_config_provider',
}

export interface IServicePluginManager {
  register(symbol: EN_SERVICE_PLUGIN_SYMBOL, service: any, description?: string): void;
  getPlugins(symbol: EN_SERVICE_PLUGIN_SYMBOL): Function[];
  // 因为可能有多个插件所以返回数组
  execute<I = null, O = null>(symbol: EN_SERVICE_PLUGIN_SYMBOL, input?: I): Promise<O[]>;
  excuteSync<I = null, O = null>(symbol: EN_SERVICE_PLUGIN_SYMBOL, input?: I): O[];
}
